import { createContext, useContext, useCallback, useRef } from "react";

const PageMetaContext = createContext();

function setDomMeta(attr, value, content) {
    let el = document.querySelector(`meta[${attr}="${value}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, value);
        document.head.appendChild(el);
    }
    el.content = content;
}

export function PageMetaProvider({ children }) {
    const currentMetaRef = useRef({
        title: "Rainbow Agro",
        description: "",
        keywords: "",
        ogImage: "",
    });

    const setMeta = useCallback((update) => {
        const values = typeof update === 'function' ? update(currentMetaRef.current) : update;
        currentMetaRef.current = { ...currentMetaRef.current, ...values };

        if (values.title) {
            document.title = values.title;
            setDomMeta('property', 'og:title', values.title);
            setDomMeta('name', 'twitter:title', values.title);
        }
        if (values.description !== undefined) {
            setDomMeta('name', 'description', values.description);
            setDomMeta('property', 'og:description', values.description);
            setDomMeta('name', 'twitter:description', values.description);
        }
        if (values.keywords !== undefined) {
            setDomMeta('name', 'keywords', values.keywords);
        }
        if (values.ogImage) {
            setDomMeta('property', 'og:image', values.ogImage);
            setDomMeta('name', 'twitter:image', values.ogImage);
        }
    }, []);

    return (
        <PageMetaContext.Provider value={{ setMeta }}>
            {children}
        </PageMetaContext.Provider>
    );
}

export function usePageMeta() {
    return useContext(PageMetaContext);
}
